import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

interface VideoGenerationState {
  status: 'pending' | 'processing' | 'completed' | 'failed';
  generatedVideoUrl?: string;
  error?: string;
}

export const useVideoGeneration = (orderId: string | null) => {
  const [state, setState] = useState<VideoGenerationState>({
    status: 'pending'
  });

  useEffect(() => {
    if (!orderId) return;

    const unsubscribe = onSnapshot(
      doc(db, 'orders', orderId),
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setState({
            status: data.status || 'pending',
            generatedVideoUrl: data.generatedVideoUrl,
            error: data.error
          });
        }
      },
      (error) => {
        console.error('Error watching video generation:', error);
        setState(prev => ({
          ...prev,
          status: 'failed',
          error: 'Failed to watch video generation status'
        }));
      }
    );

    return () => unsubscribe();
  }, [orderId]);

  return state;
};